// extracted by mini-css-extract-plugin
export var contrastLow = "_g-1";
export var externalLink = "_g-2";
export var externalLinkIcon = "_g-3";
export var link = "_g-0";
export var linkLabel = "_g-4";